import { getApiUrl } from '@/config/api'

// URL builder for a coach's own learner-facing profile.
//
// One URL for both verbs, because it is one resource: `GET` reads it and `PUT`
// writes the fields it is sent. Self only, so there is no id in it — an admin
// filling in a profile for a coach who never will uses the admin coach endpoint,
// where the rest of a coach's attributes already live.

export const coachProfileService = {
  getMyProfileUrl: () => getApiUrl('/coaching/my-profile'),
}
